<template>

  <div>
    <v-dialog v-model="isDisplayed"
              :persistent="true"
              max-width="700px">
      <v-card>
        <p class="dialog-title">{{ dialogTitle }}</p>
        <v-card-text>
          <v-container fluid="fluid" grid-list-xl="grid-list-xl">

            <!-- NAME -->
            <v-flex>
              <v-text-field v-model="editedClub.name" label="Name" placeholder="Name"></v-text-field>
            </v-flex>

            <!-- ALIAS -->
            <v-flex>
              <v-text-field v-model="editedClub.alias" label="Alias" placeholder="Alias"></v-text-field>
            </v-flex>

            <!-- LOGO -->
            <v-flex>
              <p class="input-label my-1">Logo</p>

              <!-- logo exists -->
              <div class="club-logo-section" v-if="editedClub.logo.url && !logoUploaderToggled">
                <div class="club-logo-container">
                  <img class="club-logo-img" :src="editedClub.logo.url"/>
                </div>
                <div class="add-button" @click="toggleLogoUploader">
                  <v-icon title="Add logo">mdi-plus</v-icon>
                  <p class="add-txt">Change logo</p>
                </div>
              </div>

              <!-- no logo -->
              <div class="add-button" v-if="!editedClub.logo.url && !logoUploaderToggled" @click="toggleLogoUploader">
                <v-icon title="Add logo">mdi-plus</v-icon>
                <p class="add-txt">Add logo</p>
              </div>

              <!-- logo uploader -->
              <div v-if="logoUploaderToggled">
                <LogoUploader :editedImage="null"
                              :creating="true"
                              :aspectRatio="1"
                              @logoValidated="logoValidated"
                              @logoCanceled="logoCanceled"/>
              </div>
            </v-flex>

            <!-- SPORT -->
            <v-flex>
              <SportSelector :currentSportIDs="editedClub.sportID"
                             @sportSelected="sportSelected"/>
            </v-flex>

            <!-- FEDERATION -->
            <v-flex>
              <FederationSelector :sportID="editedClub.sportID"
                                  :currentFederationID="editedClub.federationID"
                                  @federationSelected="federationSelected"/>
            </v-flex>

            <!-- REGION -->
            <v-flex>
              <RegionSelector :federationID="editedClub.federationID"
                              :currentRegionID="editedClub.regionID"
                              @regionSelected="regionSelected"/>
            </v-flex>

            <!-- TYPE -->
            <v-flex v-if="$country === 'US'">
              <ClubTypeSelector :currentType="editedClub.type"
                              @typeSelected="typeSelected"/>
            </v-flex>

          </v-container>

          <!-- BUTTONS -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="close">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="save">{{ dialogButton }}</v-btn>
          </v-card-actions>

          <!-- ERROR -->
          <v-flex>
            <v-spacer></v-spacer>
            <div class="error-message">{{ errorMessage }}</div>
          </v-flex>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import LogoUploader from '../common/LogoUploader'
import SportSelector from '../common/SportSelector'
import FederationSelector from '../common/FederationSelector'
import RegionSelector from '../common/RegionSelector'
import ClubTypeSelector from '../common/ClubTypeSelector'

export default {
  name: 'Dialog',
  components: {
    LogoUploader,
    SportSelector,
    FederationSelector,
    RegionSelector,
    ClubTypeSelector
  },
  props: [
    'dialog',
    'dialogState',
    'currentEditedClub',
    'errorMessage'
  ],
  data () {
    return {
      isDisplayed: false,

      editedClub: {
        name: '',
        alias: '',
        logo: {
          url: '',
          file: ''
        },
        sportID: '',
        federationID: '',
        regionID: '',
        type: ''
      },

      logoUploaderToggled: false
    }
  },
  mounted () {
    if (this.currentEditedClub) {
      this.setCurrentEditedClub()
    }
    if (this.dialog) {
      this.isDisplayed = true
    }
  },
  methods: {
    setCurrentEditedClub () {
      this.editedClub = {
        name: this.currentEditedClub.name,
        alias: this.currentEditedClub.alias,
        logo: {
          url: this.currentEditedClub.logoURL,
          file: ''
        },
        sportID: this.currentEditedClub.sportID,
        federationID: this.currentEditedClub.federationID,
        regionID: this.currentEditedClub.regionID,
        type: this.currentEditedClub.type
      }
    },
    save () {
      if (this.dialogState === 'create') {
        this.$emit('createClub', this.editedClub)
      } else {
        this.$emit('editClub', this.editedClub)
      }
    },
    toggleLogoUploader () {
      this.logoUploaderToggled = true
    },

    sportSelected (sportid) {
      this.editedClub.sportID = sportid
    },
    federationSelected (federationid) {
      this.editedClub.federationID = federationid
    },
    regionSelected (regionid) {
      this.editedClub.regionID = regionid
    },
    typeSelected (type) {
      this.editedClub.type = type
    },

    logoValidated (file) {
      this.editedClub.logo.file = file
    },
    logoCanceled () {
      this.editedClub.logo.file = null
    },

    close () {
      this.clearData()
      this.isDisplayed = false
    },
    clearData () {
      this.editedClub = {
        name: '',
        alias: '',
        logo: {
          url: '',
          logoToProcess: null
        },
        sportID: '',
        federationID: '',
        regionID: '',
        type: ''
      }
      this.logoUploaderToggled = false
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogButton + ' club'
    },

    dialogButton () {
      return this.dialogState.charAt(0).toUpperCase() + this.dialogState.slice(1)
    }
  },
  watch: {
    'dialog' () {
      if (this.isDisplayed !== this.dialog) {
        this.isDisplayed = this.dialog
      }
    },
    'isDisplayed' () {
      if (!this.isDisplayed) {
        this.clearData()
        this.$emit('dialogClosed')
      }
    },
    'currentEditedClub' () {
      if (this.currentEditedClub) {
        this.setCurrentEditedClub()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .dialog-title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
  }

  .input-label {
    font-size: 0.84rem;
    color: #757575;
  }

  .club-logo-section {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
  }

  .club-logo-container {
    margin-bottom: 20px;
    background-color: white;
    border: 1px solid #888888;
    border-radius: 50%;
    overflow: hidden;
    width: 42px;
    height: 42px;
    display: grid;
  }

  .club-logo-img {
    max-width: 30px;
    max-height: 30px;
    align-self: center;
    justify-self: center;
  }

  .add-button {
    cursor: pointer;
    border: 1px solid #cccccc;
    padding: 4px 6px;
    width: fit-content;
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
    &:hover {
      background-color: #e8e8e8;
    }
  }

  .add-txt {
    color: #757575;
    align-self: center;
    margin-bottom: 0;
    margin-right: 12px;
  }

  .error-message {
    color: red;
    text-align: end;
    font-weight: 700;
  }

</style>



// WEBPACK FOOTER //
// src/components/clubs/Dialog.vue